import { render } from "./cc-amex-icon.svg?vue&type=template&id=2d4f8414"
import script from "./cc-amex-icon.svg?vue&type=script&lang=js"
export * from "./cc-amex-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src844/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__